export const defaultState = {
    requestId: null,
    requestDetails: null
}

export default function cashlessVaccination(state = defaultState, action) {
    switch (action.type) {
        case "SHOW_PHYSIOTHERAPY_REQUEST_MODAL": {
            const showRequestDetails = action.payload.showRequestDetails;
            const requestId = action.payload.requestId;
            return Object.assign({}, state, {
                requestId,
                showRequestDetails
            })
        }
        case "HIDE_PHYSIOTHERAPY_REQUEST_MODAL": {
            const showRequestDetails = action.payload.showRequestDetails;
            const requestId = action.payload.requestId;
            return Object.assign({}, state, {
                requestId,
                showRequestDetails
            })
        }
        default:
            return state
    }
}